<template>
  <div>
    <Modal v-model="resModal" :mask-closable="false" footer-hide width="60">
      <p slot="header" class="text-center">选择资源</p>
      <Tabs v-model="resBoxShow" size="small">
        <TabPane label="选择资源" name="tab_choice">
          <div>
            <Row :gutter="8" class="m-b-5">
              <i-col span="3">
                <Select
                  v-model="resQuery.assetId"
                  :cleable="false"
                  size="small"
                  placeholder="选择资产"
                  @on-change="handleChangeAsset"
                >
                  <Option
                    v-for="item in showAssetArray"
                    :key="'aid_' + item.id"
                    :value="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </i-col>
              <i-col span="3">
                <i-select
                  size="small"
                  placeholder="站点（可搜索）"
                  clearable
                  filterable
                  v-model="resQuery.stationId"
                >
                  <i-option
                    :value="item.id"
                    v-for="item in stationArray"
                    :key="item.id"
                    >{{ item.name }}</i-option
                  >
                </i-select>
              </i-col>
              <i-col span="3">
                <i-select
                  size="small"
                  placeholder="位置"
                  clearable
                  v-model="resQuery.position"
                >
                  <i-option
                    v-for="item in positionArray"
                    :value="item.value"
                    :key="'pos_' + item.value"
                    >{{ item.name }}</i-option
                  >
                </i-select>
              </i-col>
              <i-col span="3">
                <i-select
                  size="small"
                  placeholder="资源类型(可搜索)"
                  clearable
                  filterable
                  v-model="resQuery.resourcetypeId"
                >
                  <OptionGroup
                    v-for="item in resourceTypeArray"
                    :key="'re_parent_' + item.id"
                    :label="item.name"
                  >
                    <Option
                      v-for="child in item.children"
                      :value="child.id"
                      :key="'re_child' + child.id"
                      >{{ child.name }}
                    </Option>
                  </OptionGroup>
                </i-select>
              </i-col>
              <i-col span="2">
                <i-select
                  size="small"
                  placeholder="等级"
                  clearable
                  v-model="resQuery.level"
                >
                  <i-option
                    v-for="item in levelArray"
                    :key="'level_' + item.id"
                    :value="item.id"
                    >{{ item.name }}</i-option
                  >
                </i-select>
              </i-col>
              <i-col span="2">
                <i-select
                  size="small"
                  placeholder="状态"
                  clearable
                  v-model="resQuery.enabled"
                >
                  <i-option
                    v-for="item in statusArray"
                    :key="'status_' + item.value"
                    :value="item.value"
                    >{{ item.name }}</i-option
                  >
                </i-select>
              </i-col>

              <i-col span="4">
                <i-input
                  size="small"
                  placeholder="关键字：支持名称查询"
                  v-model="resQuery.keyword"
                ></i-input>
              </i-col>
              <i-col span="4">
                <i-button
                  size="small"
                  class="m-r-5"
                  type="primary"
                  icon="ios-search"
                  @click="handleSearch"
                  >搜索</i-button
                >
                <Tooltip content="加入符合搜索条件的所有资源" placement="top-start" transfer>
                  <i-button
                    size="small"
                    class="m-r-5"
                    type="primary"
                    icon="md-add"
                    @click="onAddRes(true)"
                    >一键加入</i-button
                  >
                </Tooltip>
              </i-col>
            </Row>
            <div class="m-b-5">
              <Button
                type="success"
                size="small"
                :disabled="selectedResArray.length === 0"
                @click="onAddRes(false)"
                >确认加入</Button
              >
            </div>
            <Table
              size="small"
              stripe
              :max-height="560"
              :data="resList"
              :columns="resColumns"
              :loading="resLoading"
              @on-selection-change="handleSelectedRes"
            >
            </Table>
            <div class="paging_style">
              <Page
                size="small"
                :total="resTotal"
                :page-size="resQuery.pageSize"
                show-total
                show-elevator
                show-sizer
                :current="resQuery.pageNumber"
                :page-size-opts="[15, 50, 100, 200]"
                @on-change="handlePageChange"
                @on-page-size-change="handelChangePageSize"
              ></Page>
            </div>
          </div>
        </TabPane>
        <TabPane label="已有资源" name="tab_exist">
          <Row :gutter="8" class="m-b-5">
            <i-col span="3">
              <Select
                v-model="existResQuery.assetId"
                clearable
                size="small"
                placeholder="选择资产"
                @on-change="handleChangeExistAsset"
              >
                <Option
                  v-for="item in assetArray"
                  :key="'aid_e' + item.id"
                  :value="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </i-col>
            <i-col span="3">
              <i-select
                size="small"
                placeholder="站点（可搜索）"
                clearable
                filterable
                v-model="existResQuery.stationId"
              >
                <i-option
                  :value="item.id"
                  v-for="item in stationArray"
                  :key="item.id"
                  >{{ item.name }}</i-option
                >
              </i-select>
            </i-col>
            <i-col span="3">
              <i-select
                size="small"
                placeholder="位置"
                clearable
                v-model="existResQuery.position"
              >
                <i-option
                  v-for="item in positionArray"
                  :value="item.value"
                  :key="'pos_e' + item.value"
                  >{{ item.name }}</i-option
                >
              </i-select>
            </i-col>
            <i-col span="3">
              <i-select
                size="small"
                placeholder="资源类型(可搜索)"
                clearable
                filterable
                v-model="existResQuery.resourcetypeId"
              >
                <OptionGroup
                  v-for="item in resourceTypeArray"
                  :key="'re_parent_e' + item.id"
                  :label="item.name"
                >
                  <Option
                    v-for="child in item.children"
                    :value="child.id"
                    :key="'re_child_e' + child.id"
                    >{{ child.name }}
                  </Option>
                </OptionGroup>
              </i-select>
            </i-col>
            <i-col span="2">
              <i-select
                size="small"
                placeholder="等级"
                clearable
                v-model="existResQuery.level"
              >
                <i-option
                  v-for="item in levelArray"
                  :key="'level_e' + item.id"
                  :value="item.id"
                  >{{ item.name }}</i-option
                >
              </i-select>
            </i-col>
            <i-col span="2">
              <i-select
                size="small"
                placeholder="状态"
                clearable
                v-model="existResQuery.enabled"
              >
                <i-option
                  v-for="item in statusArray"
                  :key="'status_e' + item.value"
                  :value="item.value"
                  >{{ item.name }}</i-option
                >
              </i-select>
            </i-col>
            <i-col span="3">
              <i-select
                size="small"
                placeholder="选择开放市场"
                :clearable="true"
                v-model="existResQuery.open"
              >
                <i-option
                  v-for="item in openArray"
                  :key="'open_' + item.value"
                  :value="item.value"
                  >{{ item.name }}</i-option
                >
              </i-select>
            </i-col>
            <i-col span="4">
              <i-input
                size="small"
                placeholder="关键字：支持名称查询"
                v-model="existResQuery.keyword"
              ></i-input>
            </i-col>
            <i-col span="4">
              <i-button
                size="small"
                class="m-r-5"
                type="primary"
                icon="ios-search"
                @click="handleExistSearch"
                >搜索</i-button
              >
            </i-col>
          </Row>
          <div class="m-b-10">
            <Button
              type="primary"
              size="small"
              class="m-r-5"
              :disabled="selectedExistResIds.length === 0"
              @click="onUpdateResItem"
              >调整资源</Button
            >
            <Button
              type="error"
              size="small"
              class="m-r-5"
              :disabled="selectedExistResIds.length === 0"
              @click="handleDeleteResItem"
              >删除资源</Button
            >
          </div>
          <Table
            size="small"
            stripe
            :max-height="560"
            :data="existResArray"
            :columns="existResColumns"
            @on-selection-change="onSelectedExistRes"
          >
          </Table>
          <div class="paging_style">
            <Page
              size="small"
              :total="existResTotal"
              :page-size="existResQuery.pageSize"
              show-total
              show-elevator
              show-sizer
              :current="existResQuery.pageNumber"
              :page-size-opts="[15, 50, 100, 200]"
              @on-change="onChangeExistPage"
              @on-page-size-change="onChangeExistPageSize"
            ></Page>
          </div>
        </TabPane>
      </Tabs>
    </Modal>
    <Modal v-model="settingModal">
      <p slot="header" class="text-center">设置资源</p>
      <Row :gutter="8" class="m-b-10">
        <i-col span="4">开始结束日期</i-col>
        <i-col span="20">
          <DatePicker
            v-model="dates"
            :clearable="false"
            size="small"
            type="daterange"
            placement="bottom-end"
            placeholder="选择开始结束日期"
            style="width: 100%"
            @on-change="onChangeDates"
          >
          </DatePicker>
        </i-col>
      </Row>
      <Row :gutter="8">
        <i-col span="4">开放二级市场</i-col>
        <i-col span="20">
          <i-select
            size="small"
            placeholder="选择开放市场"
            :clearable="false"
            v-model="open"
          >
            <i-option
              v-for="item in openArray"
              :key="'open_' + item.value"
              :value="item.value"
              >{{ item.name }}</i-option
            >
          </i-select>
        </i-col>
      </Row>
      <div slot="footer">
        <Button type="text" @click="settingModal = false">取消</Button>
        <Button type="primary" @click="handleConfirmRes">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  getPositions,
  getResourcePage,
  addPackageResource,
  deletePackageResource,
  updatePackageResource,
  getPackageResources,
  updatePackageResources
} from '@/api/product/resource'
import {
  getResourceTypeList,
  getPublisherProductAssetList
} from '@/api/product/asset'
import { getStationByAssetIds } from '@/api/product/station'
export default {
  props: {
    packageId: {
      type: Number,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      resModal: false,
      resBoxShow: 'tab_exist',
      resLoading: false,
      resQuery: {
        pageSize: 15,
        pageNumber: 1,
        assetId: null,
        assetIdList: [],
        stationId: null,
        enabled: 1,
        position: null,
        level: null,
        resourcetypeId: null,
        packageId: null,
        projectId: null,
        notInPackageId: null,
        keyword: ''
      },
      assetArray: [],
      showAssetArray: [],
      stationArray: [],
      positionArray: [],
      resourceTypeArray: [],
      levelArray: [
        { id: -2, name: 'B' },
        { id: 1, name: 'A' },
        { id: 2, name: 'A+' },
        { id: 3, name: 'A++' },
        { id: 4, name: 'S' },
        { id: 5, name: 'S+' },
        { id: 6, name: 'S++' },
        { id: 7, name: 'S+++' }
      ],
      statusArray: [
        { value: 1, name: '可用' },
        { value: 0, name: '不可用' }
      ],
      resList: [],
      resTotal: 0,
      resColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '编号', align: 'center', key: 'code' },
        { title: '所属站点', align: 'center', key: 'stationName' },
        { title: '资源类型', align: 'center', key: 'resourcetypeName' },
        { title: '等级', align: 'center', key: 'levelName' },
        {
          title: '状态',
          align: 'center',
          key: 'enabled',
          render: (h, params) => {
            return h('span', params.row.enabled ? '可用' : '不可用')
          }
        }
      ],
      existResQuery: {
        pageSize: 15,
        pageNumber: 1,
        assetId: null,
        stationId: null,
        enabled: 1,
        position: null,
        level: null,
        resourcetypeId: null,
        packageId: null,
        projectId: null,
        open: null,
        keyword: ''
      },
      selectedResArray: [],
      selectedExistResIds: [],
      existResArray: [],
      existResTotal: 0,
      existResColumns: [
        { type: 'selection', width: 60, align: 'center' },
        {
          title: '编号',
          align: 'center',
          key: 'resourceCode',
          render: (h, { row }) => {
            return h('span', row.code || '/')
          }
        },
        {
          title: '站点',
          align: 'center',
          render: (h, { row }) => {
            return h(
              'span',
              row.assetName ? `${row.assetName} - ${row.stationName}` : '/'
            )
          }
        },
        {
          title: '资源类型',
          align: 'center',
          render: (h, { row }) => {
            return h('span', row.resourcetypeName || '/')
          }
        },
        {
          title: '等级',
          align: 'center',
          render: (h, { row }) => {
            return h('span', row.levelName || '/')
          }
        },
        { title: '位置', align: 'center', key: 'positionName' },
        {
          title: '开放市场',
          align: 'center',
          key: 'open',
          render: (h, { row }) => {
            let name = '不开放二级市场'
            let color = 'default'
            switch (row.open) {
              case 0:
                color = 'default'
                name = '不开放二级市场'
                break
              case 1:
                name = '开放到二级市场'
                color = 'primary'
                break
              case 2:
                name = '二级市场只能购买临近档期'
                color = 'warning'
                break
            }
            return h(
              'Tag',
              {
                props: {
                  color: color
                }
              },
              name
            )
          }
        },
        {
          title: '起止日期',
          align: 'center',
          width: 180,
          render: (h, { row }) => {
            return h('span', `${row.startDate} 至 ${row.endDate}`)
          }
        }
      ],
      settingModal: false,
      opType: 'add',
      openArray: [
        { value: '0', name: '不开放二级市场' },
        { value: '1', name: '开放到二级市场' },
        { value: '2', name: '二级市场只能购买临近档期' }
      ],
      dates: [],
      startDate: '',
      endDate: '',
      open: '0',
      isBatchAdd: false, // 是否一键加入
      assetIdList: [],
      selecteAssetIds: []
    }
  },
  // computed: {
  //   opType () {
  //     return this.$store.state.productManage.opType
  //   }
  // },
  methods: {
    showModal () {
      this.resBoxShow = 'tab_exist'
      // this.resQuery.assetId = this.assetIds[0]
      this.resQuery.projectId = this.projectId
      this.resQuery.notInPackageId = this.packageId
      this.existResQuery.packageId = this.packageId
      this.existResQuery.projectId = this.projectId
      this.assetIdList = []
      this.selectedResArray = []
      this.selectedExistResIds = []
      this.initAssetArray()
      this.getExistResData()
      this.resModal = true
    },
    handleChangeAsset () {
      this.assetIdList = []
      if (this.resQuery.assetId === 0) {
        this.assetIdList = this.assetArray.map(x => x.id)
        this.resQuery.assetIdList = JSON.stringify(this.assetIdList)
      }

      this.selecteAssetIds = this.resQuery.assetId === 0 ? this.assetIdList : [this.resQuery.assetId]

      this.resQuery.stationId = undefined
      this.resQuery.position = undefined
      this.resQuery.resourcetypeId = undefined
      this.initStationArray()
      this.getPositionData()
      this.getResourceTypeData()
      this.handleSearch()
    },
    handleChangeExistAsset () {
      this.selecteAssetIds = this.existResQuery.assetId ? [this.existResQuery.assetId] : []
      this.existResQuery.stationId = undefined
      this.existResQuery.position = undefined
      this.existResQuery.resourcetypeId = undefined
      this.initStationArray()
      this.getPositionData()
      this.getResourceTypeData()
      this.handleExistSearch()
    },
    // 初始化资产选项，并默认选中第一条
    initAssetArray () {
      getPublisherProductAssetList().then((res) => {
        if (res && !res.errcode) {
          this.assetArray = res
          this.showAssetArray = [{ id: 0, name: '全部线路' }, ...this.assetArray]
          if (this.assetArray.length) {
            this.resQuery.assetId = this.assetArray[0].id
            this.existResQuery.assetId = this.assetArray[0].id
            this.selecteAssetIds = [this.assetArray[0].id]

            this.initStationArray()
            this.getPositionData()
            this.getResourceTypeData()
            this.getResData()
          }
        }
      })
    },
    // 初始化站点选项
    initStationArray () {
      // this.resQuery.stationId = null
      this.stationArray = []
      if (this.selecteAssetIds.length === 0) {
        return false
      }

      getStationByAssetIds({ assetIds: JSON.stringify(this.selecteAssetIds) }).then((res) => {
        if (res && !res.errcode) {
          this.stationArray = res
        }
      })
    },
    getPositionData () {
      this.positionArray = []
      if (this.selecteAssetIds.length === 0) {
        return false
      }
      getPositions({ assetIds: JSON.stringify(this.selecteAssetIds) }).then(
        (res) => {
          if (res && !res.errcode) {
            this.positionArray = res
          }
        }
      )
    },
    /**
     * 获取资源类型数据
     */
    getResourceTypeData () {
      this.resourceTypeArray = []
      if (this.selecteAssetIds.length === 0) {
        return false
      }
      getResourceTypeList({ assetIds: JSON.stringify(this.selecteAssetIds) }).then((res) => {
        if (res && !res.errcode) {
          this.resourceTypeArray = res
        }
      })
    },
    getResData () {
      this.resLoading = true
      getResourcePage(this.resQuery)
        .then((res) => {
          if (res && !res.errcode) {
            this.resList = res.list
            this.resTotal = res.totalRow
            this.resQuery.pageNumber = res.pageNumber
            // this.resList.forEach(item => {
            //   item._checked = false
            //   if (this.selectedResArray.some(x => x.id === item.id)) {
            //     item._checked = true
            //   }
            // })
          } else {
            this.resList = []
            this.resTotal = 0
            this.resQuery.pageNumber = 1
          }
        })
        .finally(() => {
          this.resLoading = false
        })
    },
    handlePageChange (curPage) {
      this.resQuery.pageNumber = curPage
      this.getResData()
    },
    handelChangePageSize (pageSize) {
      this.resQuery.pageSize = pageSize
      this.getResData()
    },
    handleSearch () {
      this.resQuery.pageNumber = 1
      this.getResData()
    },
    handleSelectedRes (selection) {
      const curSelections = selection.map((x) => {
        return {
          id: x.id,
          code: x.code,
          duration: 1,
          period: 1
        }
      })
      this.selectedResArray = curSelections

      // // 获取当前删除的项
      // const delItems = this.resList.filter(x => !curSelections.some(s => s.id === x.id))
      // if (delItems.length) {
      //   // 排除已删除项数据
      //   this.selectedResArray = this.selectedResArray.filter(x => !delItems.some(s => s.id === x.id))
      // }

      // curSelections.forEach(item => {
      //   if (!this.selectedResArray.some(x => x.id === item.id)) {
      //     this.selectedResArray.push(item)
      //   }
      // })
    },
    handleExistSearch () {
      this.existResQuery.pageNumber = 1
      this.getExistResData()
    },
    onSelectedExistRes (selection) {
      this.selectedExistResIds = selection.map((x) => x.id)
    },
    /**
     * 获取已有资源数据
     */
    getExistResData () {
      getPackageResources(this.existResQuery).then((res) => {
        if (res && !res.errcode) {
          this.existResArray = res.list
          this.existResTotal = res.totalRow
        } else {
          this.existResArray = []
          this.existResTotal = 0
        }
      })
    },
    onChangeExistPage (curPage) {
      this.existResQuery.pageNumber = curPage
      this.getExistResData()
    },
    onChangeExistPageSize (pageSize) {
      this.existResQuery.pageSize = pageSize
      this.getExistResData()
    },
    /**
     *
     * @param isBatchAdd 是否一键加入
     */
    onAddRes (isBatchAdd = false) {
      this.isBatchAdd = isBatchAdd
      this.opType = 'add'
      this.open = '0'
      this.dates = []
      this.settingModal = true
    },
    onChangeDates (dates) {
      this.startDate = dates[0]
      this.endDate = dates[1]
    },
    /**
     * 确认加入
     */
    handleConfirmRes () {
      if (this.startDate === '' || !this.startDate) {
        this.$Notice.error({ desc: '请选择开始结束日期' })
        return
      }
      console.log(this.isBatchAdd, this.opType)
      this.$Modal.confirm({
        title: '操作提示',
        content: '确认信息无误并提交？',
        onOk: async () => {
          let result = null
          if (this.isBatchAdd === false) {
            // 批量勾选加入
            if (this.opType === 'add') {
            // 新增
              const resInfos = this.selectedResArray.map((x) => {
                return {
                  resourceId: x.id,
                  packageId: this.packageId,
                  open: Number(this.open),
                  startDate: this.startDate,
                  endDate: this.endDate
                }
              })
              // const postData = {
              //   projectId: this.projectId,
              //   packageId: this.packageId,
              //   resourceInfos: JSON.stringify(resInfos)
              // }
              result = await addPackageResource(resInfos).finally(() => {
                this.settingModal = false
              })
            } else {
            // 调整
              const datas = this.selectedExistResIds.map((m) => {
                return {
                  resourceId: m,
                  packageId: this.packageId,
                  open: Number(this.open),
                  startDate: this.startDate,
                  endDate: this.endDate
                }
              })

              result = await updatePackageResource(datas).finally(() => {
                this.settingModal = false
              })
            }
          } else {
            // 按筛选条件，一键加入
            const postData = {
              projectId: this.projectId,
              packageId: this.packageId,
              assetIdList: this.resQuery.assetId === 0 ? this.assetIdList : [this.resQuery.assetId],
              stationIdList: this.resQuery.stationId ? [this.resQuery.stationId] : [],
              positionList: this.resQuery.position ? [this.resQuery.position] : [],
              resourcetypeIdList: this.resQuery.resourcetypeId ? [this.resQuery.resourcetypeId] : [],
              level: this.resQuery.level,
              enabled: this.resQuery.enabled,
              keyword: this.resQuery.keyword,
              open: Number(this.open),
              startDate: this.startDate,
              endDate: this.endDate
            }
            result = await updatePackageResources(postData).finally(() => { this.settingModal = false })
          }

          if (result && result.success) {
            this.$Notice.success({ desc: '操作成功' })
            this.selectedResArray = []
            this.selectedExistResIds = []
            this.getExistResData()
            this.resBoxShow = 'tab_exist'
          }
        }
      })
    },

    onUpdateResItem () {
      this.opType = 'update'
      this.dates = []
      this.open = '0'
      this.settingModal = true
    },
    /**
     * 批量删除资源
     */
    handleDeleteResItem () {
      this.$Modal.confirm({
        title: '操作提示',
        content: '确定要删除所选项？',
        onOk: async () => {
          const postData = this.selectedExistResIds.map((m) => {
            return {
              resourceId: m,
              packageId: this.packageId
            }
          })
          const result = await deletePackageResource(postData)
          if (result && result.success) {
            this.$Notice.success({ desc: '操作成功' })
            this.selectedExistResIds = []
            this.getExistResData()
          }
          // this.getResData()
        }
      })
    },
    /**
     * 一键加入
     */
    onBatchAdd () {
      this.$Modal.confirm({
        title: '操作提示',
        content: '确定信息无误，并进行一键加入？',
        onOk: async () => {
          const postData = {
            projectId: this.projectId,
            packageId: this.packageId,
            assetIdList: this.resQuery.assetId ? [this.resQuery.assetId] : [],
            stationIdList: this.resQuery.stationId ? [this.resQuery.stationId] : [],
            positionList: this.resQuery.position ? [this.resQuery.position] : [],
            resourcetypeIdList: this.resQuery.resourcetypeId ? [this.resQuery.resourcetypeId] : [],
            level: this.resQuery.level,
            enabled: this.resQuery.enabled,
            keyword: this.resQuery.keyword
          }
          const res = await updatePackageResources(postData)
          if (res && res.success) {
            this.$Notice.success({ desc: '操作成功' })
            this.selectedResArray = []
            this.selectedExistResIds = []
            this.getResData()
            this.getExistResData()
            this.resBoxShow = 'tab_exist'
          }
        }
      })
    }
  }
}
</script>
